(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  define('pricelist/views/PriceListView',["jquery", "underscore", "backbone", "pricelist/views/NodesView"], function($, _, Backbone, NodesView) {
    var View;
    return View = (function(superClass) {
      extend(View, superClass);

      function View() {
        this.fetch = bind(this.fetch, this);
        this.idChange = bind(this.idChange, this);
        this.render = bind(this.render, this);
        return View.__super__.constructor.apply(this, arguments);
      }

      View.prototype.tagName = "div";

      View.prototype.className = "price-list";

      View.prototype.initialize = function() {
        $(".collapse").collapse();
        return this.bindings();
      };

      View.prototype.bindings = function() {
        this.model.on("change:layout", this.render);
        return this.model.on("change:id", this.idChange);
      };

      View.prototype.render = function() {
        var nodesView, prices;
        prices = this.model.get("Prices");
        nodesView = new NodesView({
          wholeLayout: this.layout(),
          layout: this.layout(),
          flattenHeader: this.flattenHeader(),
          sections: this.model.get("MediaSections"),
          positions: this.model.get("MediaPositions"),
          formats: this.model.get("MediaFormats"),
          variants: this.model.get("PriceVariants"),
          weekdays: this.model.get("Weekdays"),
          comments: this.model.get("Comments"),
          prices: this.model.get("Prices"),
          resetCollapseCounter: true,
          isPrint: this.model.isPrint
        });
        this.$el.hide().html(nodesView.render().el).fadeIn(1000);
        if (nodesView.counter === 1) {
          this.$el.find(".node:first").hide().end().find(".node-list").eq(1).css("padding-left", 0);
        }
        $(".collapse").collapse();
        return this;
      };

      View.prototype.idChange = function() {
        return this.fetch();
      };

      View.prototype.fetch = function() {
        return this.model.fetch({
          success: (function(_this) {
            return function() {
              var generateStructure, key;
              generateStructure = function(array, keyword) {
                var i, index, j, k, key, len, len1, len2, obj, results, value, weekdays;
                index = 1;
                _this.model.attributes[keyword + "s"] = [];
                if (keyword === "Weekday") {
                  weekdays = ["mån", "måndag", "tis", "tisdag", "ons", "onsdag", "tor", "tors", "torsdag", "fre", "fredag", "lör", "lördag", "sön", "söndag"];
                  for (i = 0, len = weekdays.length; i < len; i++) {
                    key = weekdays[i];
                    value = array[key];
                    if (value) {
                      _this.model.attributes[keyword + "s"].push({
                        Id: index,
                        Name: key,
                        Serial: index
                      });
                      for (j = 0, len1 = value.length; j < len1; j++) {
                        obj = value[j];
                        obj[keyword + "Id"] = index;
                        if (keyword === "Weekday") {
                          delete obj.Weekdays;
                        }
                        if (keyword === "Comment") {
                          delete obj.Text;
                        }
                      }
                      index++;
                      delete array[key];
                    }
                  }
                }
                results = [];
                for (key in array) {
                  value = array[key];
                  _this.model.attributes[keyword + "s"].push({
                    Id: index,
                    Name: key,
                    Serial: index
                  });
                  for (k = 0, len2 = value.length; k < len2; k++) {
                    obj = value[k];
                    obj[keyword + "Id"] = index;
                    if (keyword === "Weekday") {
                      delete obj.Weekdays;
                    }
                    if (keyword === "Comment") {
                      delete obj.Text;
                    }
                  }
                  results.push(index++);
                }
                return results;
              };

              /* Group prices by and create structure */
              generateStructure(_.groupBy(_this.model.attributes.Prices, "Weekdays"), "Weekday");
              generateStructure(_.groupBy(_this.model.attributes.Prices, "Text"), "Comment");
              _this.visiblePrices = [];
              for (key in _.groupBy(_this.model.attributes.Prices, "Colors")) {
                _this.visiblePrices.push(key);
              }
              return _this.render();
            };
          })(this)
        });
      };

      View.prototype.layout = function() {
        var layout, ref, ref1, ref2;
        layout = this.model.get("layout");
        if (((ref = this.model.get("Comments")) != null ? ref.length : void 0) === 1 && (this.model.get("Comments"))[0].Name === "") {
          layout = layout.replace(/C|c/, "");
        }
        if (((ref1 = this.model.get("Weekdays")) != null ? ref1.length : void 0) === 1 && (this.model.get("Weekdays"))[0].Name === "") {
          layout = layout.replace(/I|i/, "");
        }
        if (((ref2 = this.model.get("PriceVariants")) != null ? ref2.length : void 0) === 1 && (this.model.get("PriceVariants"))[0].Name === null) {
          layout = layout.replace(/V|v/, "");
        }
        return layout;
      };

      View.prototype.flattenHeader = function() {
        var result;
        result = this.layout().match(/[a-z]/g);
        if (result && result.length) {
          return {
            start: result[0],
            content: result,
            visiblePrices: this.visiblePrices
          };
        }
        return {
          start: "",
          content: "",
          visiblePrices: this.visiblePrices
        };
      };

      return View;

    })(Backbone.View);
  });

}).call(this);

//# sourceMappingURL=PriceListView.js.map
;
